/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Happy_Fair_Buck_DrawInputs */

const en_happy_fair_buck_draw = /** @type {(inputs: Happy_Fair_Buck_DrawInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}`)
};

const de_happy_fair_buck_draw = /** @type {(inputs: Happy_Fair_Buck_DrawInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.date}`)
};

/**
* | output |
* | --- |
* | "{date}" |
*
* @param {Happy_Fair_Buck_DrawInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_fair_buck_draw = /** @type {((inputs: Happy_Fair_Buck_DrawInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Fair_Buck_DrawInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_fair_buck_draw(inputs)
	return de_happy_fair_buck_draw(inputs)
});